import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Types } from 'mongoose';
import { BehaviorSubject, Observable } from 'rxjs';

import { ENDPOINTS, STAGE_ROUTING_STATUS, URLS } from '@shared/constants';
import {
  CommonResponseDTO,
  IMappingRequest,
  IMappingResponse,
  INodeFormSavePayload,
  IWorkflow,
} from '@shared/interfaces';
import { generateURL } from '@shared/utils';

export interface NoticeDTO {
  _id?: string;
  title: string;
  start_date: Date;
  start_time: Date;
  end_date: Date;
  end_time: Date;
  body?: string;
  featured_image?: string;
  is_deleted?: boolean;
  is_draft?: boolean;
  is_published?: boolean;
  last_modified_on?: string;
  changed_by?: string | Types.ObjectId;
}

export interface GetNoticeDTO {
  count: number;
  data: NoticeDTO[];
}

@Injectable({
  providedIn: 'root',
})
export class VirtualModuleFormBuilderService {
  private workflowIdSubject = new BehaviorSubject<string | null>(null);
  workflowId$ = this.workflowIdSubject.asObservable();

  setWorkflowId(id: string) {
    this.workflowIdSubject.next(id);
  }
  constructor(private http: HttpClient) {}
  // public getMappings(
  //   params: HttpParams
  // ): Observable<CommonResponseDTO<INodeFormSavePayload[]>> {
  //   const url = generateURL({
  //     endpoint: ENDPOINTS.INTEGRATION_MAPPINGS_GET_ALL,
  //   });
  //   const config = { params };
  //   return this.http.get<CommonResponseDTO<IMappingResponse[]>>(url, config);
  // }

  // public createMapping(
  //   mapping: IMappingRequest
  // ): Observable<CommonResponseDTO<IMappingResponse>> {
  //   const url = generateURL({
  //     endpoint: ENDPOINTS.INTEGRATION_MAPPINGS_ADD_ONE,
  //   });
  //   return this.http.post<CommonResponseDTO<IMappingResponse>>(url, mapping);
  // }

  public updateAMapping(
    mapping: IMappingRequest,
    id: string
  ): Observable<CommonResponseDTO<IMappingResponse>> {
    const url = generateURL({
      endpoint: ENDPOINTS.INTEGRATION_MAPPINGS_UPDATE_ONE,
      params: { id },
    });
    return this.http.patch<CommonResponseDTO<IMappingResponse>>(url, mapping);
  }

  public deleteMapping(
    id: string
  ): Observable<CommonResponseDTO<IMappingResponse>> {
    const url = generateURL({
      endpoint: ENDPOINTS.INTEGRATION_MAPPINGS_DELETE_ONE,
      params: { id },
    });
    return this.http.delete<CommonResponseDTO<IMappingResponse>>(url);
  }

  public restoreMapping(
    id: string
  ): Observable<CommonResponseDTO<IMappingResponse>> {
    const url = generateURL({
      endpoint: ENDPOINTS.INTEGRATION_MAPPINGS_RESTORE_ONE,
      params: { id },
    });
    return this.http.patch<CommonResponseDTO<IMappingResponse>>(url, {});
  }
  public verifyMapping(
    id: string
  ): Observable<CommonResponseDTO<IMappingResponse>> {
    const url = generateURL({
      endpoint: ENDPOINTS.INTEGRATION_MAPPINGS_VERIFY_ONE,
      params: { id },
    });
    return this.http.patch<CommonResponseDTO<IMappingResponse>>(url, {});
  }
  //correct
  public getAllRequestDocuments(
    id: string,
    params: HttpParams
  ): Observable<CommonResponseDTO<INodeFormSavePayload[]>> {
    const url = generateURL({
      endpoint: ENDPOINTS.VIRTUAL_MODULES_MODULE_INFO_GET_ALL,
      params: { id },
    });
    const config = { params };
    return this.http.get<CommonResponseDTO<INodeFormSavePayload[]>>(
      url,
      config
    );
  }
  //correct
  public getRequestDocumentResponse(
    id: string,
    formData: INodeFormSavePayload,
    status: string
  ): Observable<CommonResponseDTO<INodeFormSavePayload>> {
    const url = generateURL({
      endpoint: ENDPOINTS.VIRTUAL_MODULES_MODULE_INFO_GET_RESPONSE,
      params: { id },
    });
    return this.http.patch<CommonResponseDTO<INodeFormSavePayload>>(
      url,
      formData,
      {
        params: { status },
      }
    );
  }

  public getRequestDocumentByStatus(
    id: string,
    status: string
  ): Observable<CommonResponseDTO<INodeFormSavePayload[]>> {
    const url = generateURL({
      endpoint: ENDPOINTS.VIRTUAL_MODULES_MODULE_INFO_GET_BY_STATUS,
      params: { id },
    });
    return this.http.get<CommonResponseDTO<INodeFormSavePayload[]>>(url, {
      params: { status },
    });
  }

  //correct
  public getVirtualModuleDataById(
    id: string,
    virtual_module_id: string
  ): Observable<CommonResponseDTO<INodeFormSavePayload>> {
    const url = generateURL({
      endpoint: ENDPOINTS.VIRTUAL_MODULES_MODULE_INFO_GET_ONE,
      params: { virtual_module_id, id },
    });
    return this.http.get<CommonResponseDTO<INodeFormSavePayload>>(url, {});
  }

  // Public fetch for external collection/evaluation pages (no auth required)
  public getPublicVirtualModuleDataById(
    virtual_module_id: string
  ): Observable<CommonResponseDTO<INodeFormSavePayload>> {
    const url = `/api/virtual-modules/${'dummy'}/data/collection-info/${virtual_module_id}/public`;
    return this.http.get<CommonResponseDTO<INodeFormSavePayload>>(url);
  }

  //correct
  public getWorkflowData(id: string): Observable<CommonResponseDTO<IWorkflow>> {
    const url = generateURL({
      endpoint: ENDPOINTS.VIRTUAL_MODULES_GET_ONE_WORKFLOW,
      params: { id },
    });
    return this.http.get<CommonResponseDTO<IWorkflow>>(url);

    // return of({
    //   statusCode: 200,
    //   message: 'Success',
    //   success: true,
    //   data: workflowData,
    // });
  }

  //correct
  public updateVirtualModuleData(
    id: string,
    virtual_module_id: string,
    document: INodeFormSavePayload
  ): Observable<CommonResponseDTO<IMappingResponse>> {
    const url = generateURL({
      endpoint: ENDPOINTS.VIRTUAL_MODULES_MODULE_INFO_UPDATE_ONE,
      params: { virtual_module_id, id },
    });
    return this.http.patch<CommonResponseDTO<IMappingResponse>>(url, document);
  }
  //correct

  public createVirtualModuleData(
    id: string,
    document: INodeFormSavePayload
  ): Observable<CommonResponseDTO<INodeFormSavePayload>> {
    const url = generateURL({
      endpoint: ENDPOINTS.VIRTUAL_MODULES_MODULE_INFO_ADD_ONE,
      params: { id },
    });
    return this.http.post<CommonResponseDTO<INodeFormSavePayload>>(
      url,
      document
    );
  }

  public deleteRequestDocument(id: string, virtual_module_id: string) {
    const url = generateURL({
      endpoint: ENDPOINTS.VIRTUAL_MODULES_MODULE_INFO_DELETE_ONE,
      params: { virtual_module_id, id },
    });
    return this.http.delete<CommonResponseDTO<INodeFormSavePayload>>(url);
  }

  public restoreRequestDocument(id: string, virtual_module_id: string) {
    const url = generateURL({
      endpoint: ENDPOINTS.VIRTUAL_MODULES_MODULE_INFO_RESTORE_ONE,
      params: { id, virtual_module_id },
    });
    return this.http.patch<CommonResponseDTO<INodeFormSavePayload>>(url, {});
  }

  // public createRequestDocument(
  //   requestDocument: NoticeDTO
  // ): Observable<CommonResponseDTO<NoticeDTO>> {
  //   return this.http.post<CommonResponseDTO<NoticeDTO>>(
  //     URLS.ARCHIVE_MAIL,
  //     requestDocument
  //   );
  // }

  // public createDraftRequestDocument(
  //   requestDocument: NoticeDTO
  // ): Observable<CommonResponseDTO<NoticeDTO>> {
  //   return this.http.post<CommonResponseDTO<NoticeDTO>>(
  //     URLS.REQUEST_DOCUMENTS_DRAFT,
  //     requestDocument
  //   );
  // }

  // public updateRequestDocument(
  //   requestDocument: NoticeDTO,
  //   id: string
  // ): Observable<CommonResponseDTO<NoticeDTO>> {
  //   const url = `${URLS.ARCHIVE_MAIL}/${id}`;
  //   return this.http.put<CommonResponseDTO<NoticeDTO>>(url, requestDocument);
  // }

  public publishRequestDocument(
    id: string
  ): Observable<CommonResponseDTO<NoticeDTO>> {
    const url = `${URLS.ARCHIVE_MAIL}/${id}/publish`;
    return this.http.patch<CommonResponseDTO<NoticeDTO>>(url, {});
  }

  public unpublishRequestDocument(
    id: string
  ): Observable<CommonResponseDTO<NoticeDTO>> {
    const url = `${URLS.ARCHIVE_MAIL}/${id}/unpublish`;
    return this.http.patch<CommonResponseDTO<NoticeDTO>>(url, {});
  }

  // Get form field definition by formControlName for external collection
  public getFormFieldByControlName(
    workflowId: string,
    virtualModuleDataId: string,
    formControlName: string,
    isExternal = true
  ): Observable<CommonResponseDTO<any>> {
    const url = `/api/virtual-modules/${workflowId}/data/${virtualModuleDataId}/form-field/${formControlName}`;
    return this.http.get<CommonResponseDTO<any>>(url, {
      params: { is_external: isExternal.toString() },
    });
  }

  // Submit form data for external collection
  public submitFormData(
    id: string,
    formData: {
      formValues?: Record<string, unknown>;
      documents?: any[];
      formFieldDocuments?: any[];
    },
    status: 'save' | 'draft' = 'save'
  ): Observable<CommonResponseDTO<INodeFormSavePayload>> {
    const url = `/api/virtual-modules/${id}/data/collection-info/${id}/response`;
    return this.http.patch<CommonResponseDTO<INodeFormSavePayload>>(
      url,
      formData,
      {
        params: { status },
      }
    );
  }

  public evaluateFormData(
    id: string,
    formData: {
      formValues?: Record<string, unknown>;
      documents?: any[];
      formFieldDocuments?: any[];
    },
    status:
      | STAGE_ROUTING_STATUS.APPROVED
      | STAGE_ROUTING_STATUS.REJECTED
      | STAGE_ROUTING_STATUS.RETURNED = STAGE_ROUTING_STATUS.REJECTED
  ): Observable<CommonResponseDTO<INodeFormSavePayload>> {
    const url = `/api/virtual-modules/${id}/data/collection-info/${id}/evaluate`;
    return this.http.patch<CommonResponseDTO<INodeFormSavePayload>>(
      url,
      formData,
      {
        params: { status },
      }
    );
  }

  // Send document request email to customer
  public sendDocumentRequestEmail(
    workflowId: string,
    virtualModuleId: string,
    emailData: {
      customerEmail: string;
      customerName?: string;
    }
  ): Observable<CommonResponseDTO<any>> {
    const url = generateURL({
      endpoint: ENDPOINTS.VIRTUAL_MODULES_SEND_EMAIL,
      params: { id: workflowId, virtual_module_id: virtualModuleId },
    });
    return this.http.post<CommonResponseDTO<any>>(url, emailData);
  }

  // Get collection URL with token for external document upload
  public getCollectionUrlWithToken(
    workflowId: string,
    virtualModuleId: string
  ): Observable<
    CommonResponseDTO<{
      collectionUrl: string;
      virtualModuleId: string;
      workflowId: string;
    }>
  > {
    const url = generateURL({
      endpoint: ENDPOINTS.VIRTUAL_MODULES_GET_COLLECTION_URL,
      params: { id: workflowId, virtual_module_id: virtualModuleId },
    });
    return this.http.get<
      CommonResponseDTO<{
        collectionUrl: string;
        virtualModuleId: string;
        workflowId: string;
      }>
    >(url);
  }
}
